import {
  FETCH_MY_EXPERT_SERVICES_REQUEST,
  FETCH_MY_EXPERT_SERVICES_SUCCESS,
  FETCH_MY_EXPERT_SERVICES_FAIL,
  FETCH_EXPERT_SERVICE_BY_ID_REQUEST,
  FETCH_EXPERT_SERVICE_BY_ID_SUCCESS,
  FETCH_EXPERT_SERVICE_BY_ID_FAIL,
  CREATE_EXPERT_SERVICE_REQUEST,
  CREATE_EXPERT_SERVICE_SUCCESS,
  CREATE_EXPERT_SERVICE_FAIL,
  UPDATE_EXPERT_SERVICE_REQUEST,
  UPDATE_EXPERT_SERVICE_SUCCESS,
  UPDATE_EXPERT_SERVICE_FAIL,
  TOGGLE_EXPERT_SERVICE_ACTIVE_REQUEST,
  TOGGLE_EXPERT_SERVICE_ACTIVE_SUCCESS,
  TOGGLE_EXPERT_SERVICE_ACTIVE_FAIL,
  DELETE_EXPERT_SERVICE_REQUEST,
  DELETE_EXPERT_SERVICE_SUCCESS,
  DELETE_EXPERT_SERVICE_FAIL,
  FETCH_EXPERT_SERVICES_BY_EXPERT_REQUEST,
  FETCH_EXPERT_SERVICES_BY_EXPERT_SUCCESS,
  FETCH_EXPERT_SERVICES_BY_EXPERT_FAIL,
  RESET_EXPERT_SERVICES_ERROR,
} from "./expertServicesTypes";

const initialState = {
  myServices: [],
  viewedService: null,
  servicesByExpert: [],
  loadingMyServices: false,
  loadingMutation: false,
  loadingView: false,
  loadingByExpert: false,
  error: null,
};

export const expertServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MY_EXPERT_SERVICES_REQUEST:
      return {
        ...state,
        loadingMyServices: true,
        error: null,
      };
    case FETCH_MY_EXPERT_SERVICES_SUCCESS: {
      const raw = action.payload?.body ?? action.payload;
      const list = raw?.items ?? (Array.isArray(raw) ? raw : []);
      return {
        ...state,
        loadingMyServices: false,
        myServices: Array.isArray(list) ? list : [],
      };
    }
    case FETCH_MY_EXPERT_SERVICES_FAIL:
      return {
        ...state,
        loadingMyServices: false,
        error: action.payload,
      };

    case FETCH_EXPERT_SERVICE_BY_ID_REQUEST:
      return {
        ...state,
        loadingView: true,
        error: null,
      };
    case FETCH_EXPERT_SERVICE_BY_ID_SUCCESS:
      return {
        ...state,
        loadingView: false,
        viewedService: action.payload,
      };
    case FETCH_EXPERT_SERVICE_BY_ID_FAIL:
      return {
        ...state,
        loadingView: false,
        error: action.payload,
      };

    case CREATE_EXPERT_SERVICE_REQUEST:
    case UPDATE_EXPERT_SERVICE_REQUEST:
    case TOGGLE_EXPERT_SERVICE_ACTIVE_REQUEST:
    case DELETE_EXPERT_SERVICE_REQUEST:
      return {
        ...state,
        loadingMutation: true,
        error: null,
      };
    case CREATE_EXPERT_SERVICE_SUCCESS: {
      const service = action.payload?.body ?? action.payload;
      return {
        ...state,
        loadingMutation: false,
        myServices: service ? [...state.myServices, service] : state.myServices,
      };
    }
    case UPDATE_EXPERT_SERVICE_SUCCESS:
    case TOGGLE_EXPERT_SERVICE_ACTIVE_SUCCESS: {
      const updated = action.payload?.body ?? action.payload;
      return {
        ...state,
        loadingMutation: false,
        myServices: state.myServices.map((service) =>
          service._id === updated?._id ? updated : service,
        ),
      };
    }
    case DELETE_EXPERT_SERVICE_SUCCESS:
      return {
        ...state,
        loadingMutation: false,
        myServices: state.myServices.filter(
          (service) => service._id !== action.payload,
        ),
      };
    case CREATE_EXPERT_SERVICE_FAIL:
    case UPDATE_EXPERT_SERVICE_FAIL:
    case TOGGLE_EXPERT_SERVICE_ACTIVE_FAIL:
    case DELETE_EXPERT_SERVICE_FAIL:
      return {
        ...state,
        loadingMutation: false,
        error: action.payload,
      };

    case FETCH_EXPERT_SERVICES_BY_EXPERT_REQUEST:
      return {
        ...state,
        loadingByExpert: true,
        error: null,
      };
    case FETCH_EXPERT_SERVICES_BY_EXPERT_SUCCESS:
      return {
        ...state,
        loadingByExpert: false,
        servicesByExpert: Array.isArray(action.payload) ? action.payload : [],
      };
    case FETCH_EXPERT_SERVICES_BY_EXPERT_FAIL:
      return {
        ...state,
        loadingByExpert: false,
        error: action.payload,
      };

    case RESET_EXPERT_SERVICES_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
